// extracted by mini-css-extract-plugin
export default {"root":"ProfileCompletionGuard_root__FYFzi","actions":"ProfileCompletionGuard_actions__7UAxk","primaryAction":"ProfileCompletionGuard_primaryAction__upI4H buttonFont"};